import React from 'react'
import PropTypes from 'prop-types'

import './ApiLoader.scss'

import AppApiLoader from '../AppApiLoader/AppApiLoader'
import Spinner from '../Spinner/Spinner'
import clientLogin from '../../../shared/clientLogin'

function ApiLoader({ branding = null, loading = false }) {
  const clientId = localStorage.getItem('clientId')
  return clientId && clientId === clientLogin.ADMIN ? (
    <AppApiLoader isLoading={loading} />
  ) : (
    loading && (
      <div className="client-api-loader">
        <Spinner />
      </div>
    )
  )
}

ApiLoader.propType = {
  branding: PropTypes.object,
  loading: PropTypes.bool,
}

export default ApiLoader
